import React, { useRef, useState } from "react";
import styles from "./ImageUploader.module.css";
import ProfilePic from "../../assets/images/ProfilePic1.svg";
import { useEffect } from "react";
import { Typography } from "@mui/material";

const ImageUploader = ({
  handleInputFocus,
  selectedFile,
  setSelectedFile,
  imageUrl,
  setImageUrl,
  bgColor,
}) => {
  const fileInputRef = useRef(null);
  //   const [selectedFile, setSelectedFile] = useState(null);
  //   const [imageUrl, setImageUrl] = useState(null);
  const [resetKey, setResetKey] = useState(0);
  const [showInvalidMessage, setShowInvalidMessage] = useState(false);
  useEffect(() => {
    console.log("selectedFileselectedFile", imageUrl);
  }, [selectedFile, imageUrl]);

  const handleButtonClick = (type) => {
    if (type === "upload") {
      fileInputRef.current.click();
      handleInputFocus();
    } else {
      setSelectedFile(null);
      setImageUrl(null);
      setResetKey((prevKey) => prevKey + 1);
      handleInputFocus();
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file.type.startsWith("image/")) {
      setShowInvalidMessage(true);
      return;
    }
    setShowInvalidMessage(false);
    setSelectedFile(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setImageUrl(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const isValidImageType = selectedFile?.type?.startsWith("image/");

  return (
    <div>
      <input
        key={resetKey}
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
        accept="image/*"
      />
      <div className={styles.profileImgContainer}>
        <div className={styles.profileContainer}>
          <img
            style={{
              backgroundColor: bgColor,
              objectFit: imageUrl ? "fill" : "none",
            }}
            className={styles.clientUserAccountDetailsChild1}
            alt=""
            src={imageUrl ? imageUrl : ProfilePic}
          />
          {!imageUrl && (
            <div
              className={styles.addPicture}
              onClick={() => handleButtonClick("upload")}
            >
              + Add Picture
            </div>
          )}
          {imageUrl && (
            <div
              className={styles.changePicture}
              onClick={() => handleButtonClick("upload")}
            >
              Change Picture
            </div>
          )}
          {imageUrl && (
            <div
              className={styles.removePicture}
              onClick={() => handleButtonClick("delete")}
            >
              Remove Picture
            </div>
          )}
        </div>
        {/* Invalid file type message */}
        {showInvalidMessage && (
          <div style={{ display: "flex", justifyContent: "flex-start", width: "100%" }}>
            <Typography
              sx={{
                fontSize: "12px",
                letterSpacing: "-0.02em",
                lineHeight: "16px",
                fontWeight: 500,
                fontFamily: "Montserrat",
                color: "#a50218",
                paddingTop: "8px",
              }}
            >
              Unsupported File Type! Please upload an image file.
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageUploader;
